'use strict';

import {find, findAll, register} from '../../../../JavaScript/Utils';

const Home = $el => {

    const setCookie = function(segment) {
        let expires = Date.now() + (365 * 24 * 60 * 60);
        document.cookie = "nezzo-segment=" + segment + "; expires=" + expires + "; samesite=none; secure; path=/"
    }

    $('[data-segment="business"] a, [data-nezzo-tab-target="tab-business"] a').click(() => setCookie('business'));
    $('[data-segment="kmu"] a, [data-nezzo-tab-target="tab-kmu"] a').click(() => setCookie('kmu'));
    $('[data-segment="private"] a, [data-nezzo-tab-target="tab-private"] a').click(() => setCookie('private'));
    $('[data-segment="reseller"] a, [data-nezzo-tab-target="tab-reseller"] a').click(() => setCookie('reseller'));

};

register('Home', Home);
